// engineList.js

export const SET_ENGINE_ROW = 'SET_ENGINE_ROW'
export const SET_ROW_ENGINE_ID = 'SET_ROW_ENGINE_ID'

// lineConfig.js

export const SET_LINE_LIST = 'SET_LINE_LIST'
export const SET_LINE_LIST_WEB = 'SET_LINE_LIST_WEB'
export const SET_LINE_LIST_HTTP = 'SET_LINE_LIST_HTTP'
export const SET_LINE_LIST_VPN = 'SET_LINE_LIST_VPN'

// asperaAccountConfig.js

export const SET_ASPERA_LIST = 'SET_ASPERA_LIST'
